export { default as EditForm } from "./vue/edit-form.vue";

export * from "./ts/types";